import { Autocomplete, Box, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { namedByPlaceholder } from '~/components/forms/autocomplete-label';
import { useSettingIds } from '~/components/settings';
import type { ChannelGuideSettings__Channel as Channel } from '../../queries/settings.generated';

export interface ChannelSelectProps {
  disabled?: boolean;
  onChange: (channel: Channel | null) => void;
  options: readonly Channel[];
  value: Channel | null;
}

export const ChannelSelect = ({ disabled, onChange, options, value }: ChannelSelectProps) => {
  const { t } = useTranslation();
  // Inside a settings row the row's label names the input.
  const ids = useSettingIds();

  return (
    <Autocomplete
      id={ids?.inputId}
      disabled={disabled}
      fullWidth
      autoHighlight
      getOptionLabel={(option) => `${option.name}${option.number ? ` (${option.number})` : ''}`}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      onChange={(_event, newValue) => onChange(newValue)}
      options={options}
      renderInput={(params) => (
        <TextField
          {...namedByPlaceholder(params, t('common.placeholders.select_channel'), ids != null)}
        />
      )}
      renderOption={(optionProps, option) => (
        <Box component="li" {...optionProps}>
          <Box
            sx={{ backgroundColor: option.backgroundColor, mr: 1, '& > img': { flexShrink: 0 } }}
          >
            <img
              loading="lazy"
              width="20"
              srcSet={option.thumbnailFile.uri}
              src={option.thumbnailFile.uri}
              alt=""
            />
          </Box>
          {option.name}
          {option.number ? ` (${option.number})` : ''}
        </Box>
      )}
      value={value}
    />
  );
};
